import './global.js';

import { v$ } from './includes/helpers.js';

const onlinePaymentLeftType = v$('.onlinePayment-payment-left-type');
const inputs = v$('.onlinePayment-payment-left-type input');
const submitBtn = v$('.onlinePayment-payment-left .btn')[0];
const paymentLeft = v$('.onlinePayment-payment-left')[0];
const stocks = v$('.onlinePayment-payment-left-stock');
let stockContent = v$('.onlinePayment-payment-left-stock span');


inputs.forEach( input => {
    input.addEventListener('click', e => {
        if(e.target.checked){
            let currentLink = e.target.getAttribute('data-link');
            submitBtn.setAttribute('href', currentLink);
        }
    });
});

const existenceStocks = () => {
  if (stocks) {
    stocks.forEach( stock => {
      stock.addEventListener('mouseenter', (e) => {
        let stockChild = stock.childNodes[0];
        e.target == stockChild ? (e.target.parentNode.classList.add('onlinePayment-payment-left-stock-open')) : e.target.classList.add('onlinePayment-payment-left-stock-open');
        e.target == stockChild ? e.target.nextElementSibling.classList.remove('onlinePayment-payment-left-stock-hide') : e.target;
        e.target == stock ? e.target.lastChild.classList.remove('onlinePayment-payment-left-stock-hide') : e.target;
        stockContent.forEach( item => {
          item == e.target || item == stockChild ? item.classList.add('onlinePayment-payment-left-stock-hide') : item;
        })
        stocks.forEach( item => {
          item.classList.contains('onlinePayment-payment-left-stock-open') ? item.classList.add('onlinePayment-payment-left-stock-show') : item.classList.add('onlinePayment-payment-left-stock-hide');
        })
      });
      stock.addEventListener('mouseleave', (e) => {
        let stockChild = stock.childNodes[0];
        e.target == stockChild ? e.target.parentNode.classList.remove('onlinePayment-payment-left-stock-open') : e.target.classList.remove('onlinePayment-payment-left-stock-open');
        e.target == stock ? e.target.lastChild.classList.add('onlinePayment-payment-left-stock-hide') : e.target;
        stockChild.classList.remove('onlinePayment-payment-left-stock-hide');
        stocks.forEach( item => {
          item.classList.remove('onlinePayment-payment-left-stock-hide', 'onlinePayment-payment-left-stock-show');
        })
      })
    });
    onlinePaymentLeftType.forEach (item => {
      item.classList.add('onlinePayment-payment-left-type-bg-none');
    })
  }

  else {
    paymentLeft.classList.add('onlinePayment-payment-without-stock');
  }
}

existenceStocks();
